module.exports = __webpack_public_path__ + "static/img/Jean_Cabanes_Accenture.1d46512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/Jean_Cabanes_Accenture.jpg
// module id = Fvq8
// module chunks = 0